import AnnouncementBannerWrapper from 'components/common/AnnouncementBannerWrapper'
import Button from 'components/common/Button'
import Text from 'components/common/Text'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import theme from 'theme'

const TutorialBanner = () => {
  return (
    <AnnouncementBannerWrapper
      blank
      data-test-walkthrough-intro-banner-content
      css={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        alignItems: 'center',
        padding: theme.space[3],
        marginTop: theme.space[4]
      }}
    >
      <div>
        <Text
          as="h6"
          css={{
            letterSpacing: theme.letterSpacing[5],
            color: theme.colors.steel[1]
          }}
        >
          GREMLIN COMMUNITY
        </Text>
        <Text
          as="h2"
          css={{
            marginTop: theme.space[2],
            marginBottom: theme.space[2]
          }}
        >
          Tutorials
        </Text>
        <Text
          as="p"
          css={{
            marginTop: theme.space[2],
            fontWeight: theme.fontWeights[0]
          }}
        >
          The Gremlin community provides resources and relationships to make you
          the best chaos engineer you can be. Dive into our step-by-step guides
          for running Chaos Experiments in your environment.
        </Text>
      </div>

      <Button
        secondary
        as={TrackedExternalLink}
        href="https://www.gremlin.com/community/tutorials/"
      >
        Get Started
      </Button>
    </AnnouncementBannerWrapper>
  )
}

export default TutorialBanner
